export const transactionsData = [
  { Transactions: 'All', transactionId: 0 },
  { Transactions: 'Booking', transactionId: 1 },
  { Transactions: 'Delivery', transactionId: 2 },
  { Transactions: 'Refund', transactionId: 3 },
]

export const ModesData = [0, 'B', 'D', 'R']

export const reportViewData = [
  { view: 'Detailed', id: 0 },
]

const CASH_MODE_ID = 1

export const excludeCashPaymentModes = (modes) =>
  modes.filter((mode) => mode.ModeID !== CASH_MODE_ID && mode.ModeName !== 'Cash')

export const criteriaHeaders = [
  { field: 'fromDate', header: 'From Collection Date', textAlign: 'left' },
  { field: 'toDate', header: 'To Collection Date', textAlign: 'left' },
  { field: 'selBranch', header: 'Branch', textAlign: 'left' },
  { field: 'selUser', header: 'User', textAlign: 'left' },
  { field: 'transactionType', header: 'Transaction Type', textAlign: 'left' },
  { field: 'paymentType', header: 'Payment Type', textAlign: 'left' },
  { field: 'paymentMode', header: 'Payment Mode', textAlign: 'left' },
  { field: 'selReportView', header: 'Report View', textAlign: 'left' },
]

export const normalizeTableData = (rows = []) =>
  rows.map((row) => (row?.dataType === 'header2' ? { ...row, dataType: 'header' } : row))

export const getMainHeader = (columns = []) =>
  columns.map((column) => {
    const header = column.headerName || column.header || ''
    return {
      ...column,
      header,
      exportHead: column.exportHead || header,
      align: column?.xlCol?.dataType === 'string' ? 'left' : 'right' || column.textAlign || column.align || 'left',
      weight: column?.weight ? column?.weight : 80,
    }
  })
